(function(){
  'use strict';

  function initTourCardTest(){
    if (!window.matchMedia || !window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)').matches) return;

    var cards = document.querySelectorAll(
      '.js-tourcard-products-test .tt-product.product-parent, ' +
      '.js-tourcard-categories-test .tt-items-categories'
    );

    cards.forEach(function(card){
      if (card.dataset.jsTourcardBound === '1') return;
      card.dataset.jsTourcardBound = '1';

      function move(ev){
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width;
        var py = (ev.clientY - r.top) / r.height;
        var ry = (px - 0.5) * 16;
        var rx = (0.5 - py) * 16;
        card.style.setProperty('--js-tour-rx', rx.toFixed(2) + 'deg');
        card.style.setProperty('--js-tour-ry', ry.toFixed(2) + 'deg');
        card.style.setProperty('--js-tour-scale', '1.025');
      }

      function reset(){
        card.style.setProperty('--js-tour-rx', '0deg');
        card.style.setProperty('--js-tour-ry', '0deg');
        card.style.setProperty('--js-tour-scale', '1');
      }

      card.addEventListener('pointermove', move, {passive:true});
      card.addEventListener('pointerleave', reset, {passive:true});
      card.addEventListener('pointercancel', reset, {passive:true});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTourCardTest);
  } else {
    initTourCardTest();
  }

  document.addEventListener('shopify:section:load', function(){ setTimeout(initTourCardTest, 50); });
})();
